module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "col-12 customer-feedback",
    class: _vm.noSpacing ? 'no-padding' : ''
  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('pos.postPreview.leave-feedback')))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-xl-6"
  }, [(_vm.permissions.includes("moveForward")) ? _c('b-btn', {
    staticClass: "mt-1",
    attrs: {
      "block": true,
      "variant": "success",
      "data-test": ("approve-creative" + _vm.identificator)
    },
    on: {
      "click": function($event) {
        _vm.$emit('approveCreative')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.i-like-it')))]) : _vm._e()], 1), _c('div', {
    staticClass: "col-lg-12 col-xl-6"
  }, [(_vm.permissions.includes("moveBack")) ? _c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle",
      value: (_vm.toggleElement),
      expression: "toggleElement"
    }],
    staticClass: "mt-1",
    attrs: {
      "block": true,
      "data-test": ("open-reject-creative" + _vm.identificator)
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.i-would-like-an-amendment')))]) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10ed3771"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/creative-preview-feedback/CreativePreviewFeedback.vue
// module id = 2004
// module chunks = 1